import { TFiltersData } from '../../graphql/ecp-locator/models/filter-params.models';

export const DEFAULT_FILTERS: TFiltersData = {
  shops: [],
  services: null,
  specializations: [],
  isFiltersChanged: false,
  isFirstTimeLoading: false,
};
